import Button from "@/components/Button/index";
import DexLeftComponent from '@/components/DexLeftComponent';
import { getDexConfig } from "@/utils/get-dex-config.js";
import { getEnvAndDex } from '@/utils/get-env-and-dex';
import PropTypes from "prop-types";

const DexSignupSuccess = ({ prevStep }) => {
	const { dex } = getEnvAndDex();
	const { SignupSuccessImage, SignUpSuccessTitle, SignUpSuccessContent } = getDexConfig(dex);

	return (
		<>
			<DexLeftComponent />
			<div className="layout-feedback-section">
				<div className="layout-feedback__section-header">
					<div className="layout-feedback__header">Success!</div>
					<div className="layout-feedback__section-content">
						{SignUpSuccessTitle}
					</div>
				</div>
				<div className="layout-feedback__content">
					<img src={SignupSuccessImage} alt="sign-up-success" />
				</div>
				<div className="layout-feedback__section-content">
					{SignUpSuccessContent}
				</div>
				<div className="layout-feedback__section-footer">
					<Button
						sizing="Medium"
						text="Back to Home"
						maxWidth="278"
						full
						round
						submit={() => prevStep()}
					/>
				</div>
			</div>
		</>
	);
};

export default DexSignupSuccess;


DexSignupSuccess.propTypes = {
	dex: PropTypes.string,
	prevStep: PropTypes.func,
};
